var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseCurlyBracket(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 33.195,
    height: 107.352,
    viewBox: "0 0 33.195 107.352",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_155",
    x: 0,
    y: 0,
    width: 33.195,
    height: 107.352,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.502,
    result: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_155-2",
    "data-name": "Path 155",
    d: "M1.039,13.727q11.1-3.555,11.484-18.1V-16.406q0-12.633,9.9-17.227-9.9-4.484-9.9-17.227v-11.1q0-15.422-11.43-19.086l2.078-6.289q9.68,2.734,14.547,8.887t4.922,16.27V-50.7q0,13.07,11.594,13.07v7.93q-11.594,0-11.594,13.289V-5.359q0,10.281-4.949,16.461T3.172,20.016Z",
    transform: "translate(-1.039 87.336)",
    fill: "#006151"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Path_155)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_155-3",
    "data-name": "Path 155",
    d: "M1.039,13.727q11.1-3.555,11.484-18.1V-16.406q0-12.633,9.9-17.227-9.9-4.484-9.9-17.227v-11.1q0-15.422-11.43-19.086l2.078-6.289q9.68,2.734,14.547,8.887t4.922,16.27V-50.7q0,13.07,11.594,13.07v7.93q-11.594,0-11.594,13.289V-5.359q0,10.281-4.949,16.461T3.172,20.016Z",
    transform: "translate(-1.04 87.34)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCurlyBracket);
export default __webpack_public_path__ + "static/media/close-curly-bracket.db1ba72b38d00c60e422e43b8d0c8feb.svg";
export { ForwardRef as ReactComponent };